import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-folder",
  "use": "icon-folder-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-folder\">\n\t<path fill=\"none\" d=\"M0 0h24v24H0z\" />\n\t<path d=\"M4,7.2v12H20V7.2Zm8.41-2H21a1,1,0,0,1,1,1v14a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V4.2a1,1,0,0,1,1-1h7.41Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol